"use client";
import React from "react";

import { map, get } from "utils/lodash";
import Link from "components/common/Link";
import { CATEGORIES } from "utils/constant";
import { useT } from "providers/I18nProvider";

const Comp = ({ categories }: { categories: any[] }) => {
  const t = useT();
  // CMS có thể trả danh mục mới chưa khai báo trong CATEGORIES → bỏ qua thay vì crash
  // (trước đây gán cat.id lên object undefined + ghi đè hằng số dùng chung)
  const items = map(categories, (value) => {
    const cat: any = CATEGORIES.find((c) => c.code === value.code);
    return cat ? { ...cat, id: value.id } : null;
  }).filter(Boolean) as any[];

  return (
    <div className="bg-white ">
      <div className="container mx-auto px-0 py-4 md:py-7 md:px-6">
        {/* Mobile: 1 hàng cuộn ngang (snap), mỗi ô rộng cố định để lộ mép ô kế → gợi ý cuộn.
            Desktop: flex-wrap canh giữa, ô lớn hơn + hover để rõ là bấm được. */}
        <div className="flex gap-3 overflow-x-auto scrollbar-hide snap-x snap-mandatory px-4 pb-1 md:flex-wrap md:gap-4 md:justify-center md:overflow-visible md:px-0 md:pb-0">
          {items.map((cat, index) => (
            <Link
              href={`/search?category=${get(cat, "code")}`}
              key={`cat_${index}`}
              className="group flex w-[72px] shrink-0 snap-start flex-col items-center rounded-2xl md:w-[128px] md:py-3 md:transition md:hover:bg-[#eefbfb] focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
            >
              <div className="w-[52px] h-[52px] md:w-[68px] md:h-[68px] rounded-xl md:rounded-2xl bg-gray-100 flex items-center justify-center mb-1.5 md:mb-2 transition-transform md:group-hover:-translate-y-0.5 md:group-hover:bg-white md:group-hover:shadow-md">
                {get(cat, "icon")}
              </div>
              <span className="text-[12px] leading-tight md:text-sm text-center text-gray-800 line-clamp-2 md:group-hover:text-primary-ink md:font-medium">
                {get(cat, "nameKey") ? t(cat.nameKey) : get(cat, "name")}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Comp;
